import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M4.343 2.36 21 17.067h-9.701l8.758 14.756A56 56 0 0 1 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .706-3.374 3.477-5.515",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M3.525 3.081 18.305 16H9.41l9.532 15.902A59 59 0 0 1 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .564-2.693 2.66-4.794",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.065 10.499a3.7 3.7 0 0 0-.065.688C1 13.294 2.79 15 5 15s4-1.707 4-3.812q0-.158-.013-.312c-.215 1.125-.949 2.078-1.956 2.625l-.298-.381 1.077-.44-1.077-.44.704-.9-1.162.137.143-1.118-1 .726L5.026 10l-.392 1.085-1-.726.143 1.118-1.162-.137.704.9-1.077.44 1.077.44-.283.361c-1.098-.612-1.863-1.708-1.97-2.982M5 19l.577 1.846L7 19.537l-.424 1.887L8.464 21l-1.31 1.423L9 23l-1.846.577L8.464 25l-1.888-.424L7 26.465l-1.423-1.31L5 27l-.577-1.846L3 26.464l.424-1.887L1.536 25l1.31-1.423L1 23l1.846-.577L1.536 21l1.888.424L3 19.536l1.423 1.31z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagNpl = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagNpl_default = SvgFlagNpl;

export { FlagNpl_default as default };
